export const LogGetters = {
  archives: state => state.archives,
  logs: state => state.logs,
  logsActors: state => state.logsActors,
}
